import * as React from 'react';
/**
 *
 * Original name: lock open
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A327
 *
 */
export const LockOpenPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M26 23v-8c0-3.69 3.232-5 6-5s6 1.31 6 5v2h4v-2c0-5.3-4.112-9-10-9s-10 3.7-10 9v8h-8v23a10.011 10.011 0 0 0 10 10h16a10.011 10.011 0 0 0 10-10V23H26Zm20 23a6.007 6.007 0 0 1-6 6H24a6.007 6.007 0 0 1-6-6V27h28v19Z", fill: "currentColor" }),
    React.createElement("path", { d: "M30 41.676V47h4v-5.324A4.572 4.572 0 0 0 37 37a4.642 4.642 0 0 0-5-5 4.642 4.642 0 0 0-5 5 4.572 4.572 0 0 0 3 4.676Z", fill: "currentColor" })));
